import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../mock';

const FAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-20 md:py-28">
      <div className="max-w-[880px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="text-[12px] font-bold uppercase tracking-widest text-[#F97316] mb-3">Questions</p>
          <h2 className="text-[34px] md:text-[44px] font-extrabold text-stone-900 leading-tight">
            The stuff people usually ask us on the demo call
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((item, idx) => (
            <div key={idx} className="bg-white rounded-2xl border border-stone-200 overflow-hidden">
              <button
                onClick={() => setOpen(open === idx ? -1 : idx)}
                className="w-full flex items-center justify-between gap-4 p-5 text-left hover:bg-stone-50 transition-colors"
              >
                <span className="text-[15px] md:text-[16px] font-bold text-stone-900" style={{ fontFamily: 'Plus Jakarta Sans' }}>
                  {item.q}
                </span>
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-stone-100 flex items-center justify-center">
                  {open === idx ? <Minus size={16} className="text-[#F97316]" /> : <Plus size={16} className="text-stone-700" />}
                </div>
              </button>
              <div className="grid transition-all duration-300 ease-in-out" style={{ gridTemplateRows: open === idx ? '1fr' : '0fr' }}>
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 text-[14.5px] text-stone-600 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
